export default __webpack_public_path__ + "static/media/pro-elevate-wht-banner-3.44164d0e.jpg";